import type { FC } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import ButtonText from '@segment/matcha/components/ButtonText'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import cdpReport2023Png from './assets/CdpReport2023.png'
import digitalAdvertisingPng from './assets/DigitalAdvertising.png'
import cacGuide2023Png from './assets/CacGuide2023.png'

const copy = {
  heading: `Recommended reading`,
}

const URL_PARAMS = `utm_source=ebook&utm_medium=referral&utm_campaign=all_cnt_02-05-23-state-of-personalization-report-2023_4142023&utm_content=ebook`

const cards = [
  {
    image: cdpReport2023Png,
    title: `The Customer Data Platform Report 2023`,
    description: `Our new Customer Data Platform Report analyzes real data from the Twilio Segment platform (nearly 12 trillion API calls to be exact) to examine the biggest digital trends happening in customer engagement.`,
    url: `/the-cdp-report/`,
    buttonText: `Download the report`,
  },
  {
    image: digitalAdvertisingPng,
    title: `Digital Advertising in the Cookieless World`,
    description: `Learn how to deliver personalized and more transparent experiences in the absence of third-party cookies.`,
    url: `https://learn.segment.com/digital-advertising-in-the-cookieless-world/`,
    buttonText: `Download the guide`,
  },
  {
    image: cacGuide2023Png,
    title: `Customer Acquisition Cost (CAC): A Guide for 2023`,
    description: `In this guide, we share the CAC formula and explain how to calculate it. Discover what makes a "good" CAC, how to determine an LTV:CAC ratio, and steps you can take to improve both metrics for long-term success.`,
    url: `https://learn.segment.com/customer-acquisition-cost-cac-guide/`,
    buttonText: `Download the guide`,
  },
]

const RecommendedReading: FC = () => {
  const pageConfig = usePageConfig()
  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <Heading variant="h2" tag="h3">
          {copy.heading}
        </Heading>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack columns={1} overrides={{ md: 2, lg: 3 }}>
          {cards.map((card) => (
            <StyledCardBase key={card.title} href={getAbsoluteUrl(`${card.url}?${URL_PARAMS}`, pageConfig)}>
              <Card.Image alt={card.title} src={card.image} variant="fill" />
              <Card.Body>
                <Card.Copy>
                  <Card.Headline>{card.title}</Card.Headline>
                  <Card.Description>{card.description}</Card.Description>
                </Card.Copy>
                <Card.Action>
                  <ButtonText iconEnd={ChevronRightIcon}>{card.buttonText}</ButtonText>
                </Card.Action>
              </Card.Body>
            </StyledCardBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

export default RecommendedReading

const Heading = styled(Typography)`
  margin: 0;
`

const StyledColumnTrack = styled(ColumnTrack)`
  ${({ theme }) => theme.breakpoints.up(`xl`)} {
    padding: 0 80px;
  }
`
const StyledCardBase = styled(CardBase)``
